<script setup>
import { defineProps, defineEmits, computed} from "vue";
import TabelaDeAdiantamentos from "./TabelaDeAdiantamentos/TabelaDeAdiantamentos.vue";
import TabelaDeNotasFiscaisEmitidas from "./TabelaDeNotasFiscaisEmitidas/TabelaDeNotasFiscaisEmitidas.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "parcela",
]);

const emits = defineEmits([
    "update:alteraAdiantamento",
]);

//==================================================================//
//======================= Altera Adiantamento ======================//
//==================================================================//

const alteraAdiantamento = (update)=>{

    emits('update:alteraAdiantamento',update);

};

//==================================================================//
//========================== Mostra Tabela =========================//
//==================================================================//

let mostraTabela = computed(()=>{

    if(props?.parcela?.lista?.length <= 0){
        return false;
    }

    if(props?.parcela?.aberto == false){
        return false;
    }

    return true;

});

</script>

<template>

    <div
        class="c-table__row"
        v-show="mostraTabela"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <TabelaDeAdiantamentos
                    v-if="props?.parcela?.tipoOculto == 'AD'"
                    :dado="props?.dado"
                    :parcela="props?.parcela"
                    @update:alteraAdiantamento="alteraAdiantamento"
                ></TabelaDeAdiantamentos>

                <TabelaDeNotasFiscaisEmitidas
                    v-else-if="props?.parcela?.tipoOculto == 'NF'"
                    :dado="props?.dado"
                    :parcela="props?.parcela"
                ></TabelaDeNotasFiscaisEmitidas>

            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__row:hover{
    background-color: #eeeeee;
}

.c-table__cell{
    grid-column: 3 / -1;
}

</style>
